import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: center;
  line-height: 24px;
`;

export const InvoiceNumber = styled.div`
  color: var(--section-ebony-color, var(--ebony));
  font-size: 18px;
  font-weight: 700;
  margin-right: 152px;
`;

export const InvoiceDescription = styled.div`
  color: var(--section-granite-color, var(--granite));

  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
`;

export const InvoiceDuration = styled.span`
  color: var(--section-ebony-color, var(--ebony));
  font-size: 18px;
  font-weight: 700;
  margin-right: 177px;
`;

export const DownloadButton = styled.div`
  margin-left: auto;
`;
